export enum EOrderStatus {
    PROGRESS = 'In progress',
    LOCKED = 'locked',
    FINISH = 'finish'
}

export const enum ECardType {
    PHYSICAL = 'primary',
    VIRTUAL = 'virtual'
}

export enum EPaymentSystem {
    VISA = 'visa',
    MASTERCARD = 'mastercard'
}

export enum EAccountType {
    BANK = 'bank',
    CARD = 'card'
}

export enum ECreditCardBrands {
    AMEX = 'amex',
    VISA = 'visa',
    MASTERCARD = 'mastercard',
    DISCOVER = 'discover'
}

export enum EActiveETransfer {
    SEND = 'send money',
    REQUEST = 'request money',
    CONTACTS = 'manage contacts',
    AUTODEPOSIT = 'interac autodeposit',
    INVITE = 'invite',
    SCHEDULE_PAYMENTS = 'schedule payments'
}

export enum EActivePayBills {
    PAY = 'pay bills',
    MANAGE = 'manage payees',
    SCHEDULE = 'schedule payments'
}

export enum ESchedulePaymentType {
    PAYMENTS_DATE = 1,
    NUMBER_OF_PAYMENTS = 2
}
// TODO: Refund actions should be added to this enum
export enum EFundsOperation {
    WALLET_CREDIT_TRANSFER = '1_1_4',
    WALLET_DEBIT_TRANSFER = '1_2_4',
    WALLET_CREDIT_REQUEST = '1_1_5',
    WALLET_DEBIT_REQUEST = '1_2_5',
    WALLET_CREDIT_CARD_DEPOSIT = '1_1_9',
    WALLET_CREDIT_CARD_SERVICE = '1_1_8',
    PAY_BILL_CREDIT_PAYMENT = '2_1_6',
    E_TRANSFER_CREDIT_TRANSFER = '3_1_4',
    E_TRANSFER_DEBIT_TRANSFER = '3_2_4',
    E_TRANSFER_DEBIT_REQUEST = '3_2_5',
    EFT_CREDIT_WITHDRAWAL = '4_1_3',
    EFT_DEBIT_DEPOSIT = '4_2_2',
    EPS_DEBIT_DEPOSIT = '5_2_2',
    CARD_CREDIT_WITHDRAWAL = '6_1_10',
    CARD_DEBIT_DEPOSIT = '6_2_9',
    GIFT_CARD_CREDIT_GIFT_CARD = '8_1_13',
    GIFT_CARD_DEBIT_GIFT_CARD_REDEEM = '8_2_14',
    GIFT_CARD_CREDIT_RESERVE = '8_1_15',
    GIFT_CARD_DEBIT_RESERVE = '8_2_15'
}

export enum ENewNotificationType {
    TRANSACTION = 'transaction',
    CARD = 'card',
    BILL = 'bill',
    ACCOUNT = 'account',
    USER = 'user',
    PHONE = 'phone',
    EMAIL = 'email',
    LOGOUT = 'logout',
    LOYALTY = 'loyalty',
    SUPPORT = 'support'
}

export enum EContactViewType {
    BLOCKED = 'blocked_contacts',
    CONTACTS = 'contacts'
}
